import conn from './connections';

export const get = () => conn.getJSON(`${conn.base_url}/employees`);
export const add = employee => conn.postJSON(`${conn.base_url}/employees`,employee);
export const update = employee => conn.putJSON(`${conn.base_url}/employees`,employee);
export const deleteOne = employeeId => conn.deleteJSON(`${conn.base_url}/employees/${employeeId}`);
